import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// * Redux
import { createStore } from "redux";
import { Provider } from "react-redux";
import CoM from "./redux/reducer";

// * Documentation: https://dmuy.github.io/Material-Toast/
import mdtoast from "@dmuy/toast";

import "@google/model-viewer/dist/model-viewer";

const store = createStore(CoM);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Simple Service Worker to make App Install work (OPTIONAL)

if (typeof process.env.REACT_APP_UI_URL === "undefined") {
  if ("serviceWorker" in navigator) {
    let deferredPrompt;

    window.addEventListener("load", function () {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker
          .register("/service-worker.js", { scope: "./" })
          .then(function (registration) {
            console.log("registered service worker");

            registration.onupdatefound = function () {
              // The updatefound event implies that registration.installing is set; see
              // https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-container-updatefound-event
              const installingWorker = registration.installing;

              installingWorker.onstatechange = function () {
                switch (installingWorker.state) {
                  case "installed":
                    if (!navigator.serviceWorker.controller) {
                      mdtoast(`<span role="status">Caching complete!</span>`, {
                        duration: 5000,
                        type: mdtoast.SUCCESS,
                      });
                    }
                    break;

                  case "redundant":
                    throw Error(
                      "The installing service worker became redundant."
                    );

                  default:
                    break;
                }
              };
            };
          })
          .catch(function (whut) {
            console.error("uh oh... ");
            console.error(whut);
          });
      }
    });

    window.addEventListener("beforeinstallprompt", (e) => {
      // // Prevent Chrome 76 and later from showing the mini-infobar
      // e.preventDefault();

      // Stash the event so it can be triggered later.
      deferredPrompt = e;

      // // Show the prompt
      // deferredPrompt.prompt();

      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice.then((choiceResult) => {
        console.log(choiceResult.outcome);

        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the A2HS prompt");
        } else {
          console.log("User dismissed the A2HS prompt");
        }

        // deferredPrompt = null;
      });
    });

    window.addEventListener("appinstalled", (evt) => {
      console.log("User added to homescreen");
    });

    // Check to see if the service worker controlling the page at initial load
    // has become redundant, since this implies there's a new service worker with fresh content.
    if (navigator.serviceWorker && navigator.serviceWorker.controller) {
      console.log(
        "navigator.serviceWorker.controller.onstatechange:: " +
          navigator.serviceWorker.controller.onstatechange
      );
      navigator.serviceWorker.controller.onstatechange = function (event) {
        if (event.target.state === "redundant") {
          // window.location.reload();
          mdtoast(
            `<span role="status">A new version of this app is available.  Please refresh the web app.</span>`,
            {
              type: mdtoast.SUCCESS,
            }
          );
        }
      };
    }
  }
}
